export const ZAPIER_ONBOARDING_ENDPOINT = "v1/zapier/onboarding"; // there is only one version for now, if there is a dev, add it to ENV

export const HUBSPOT_ZAPS = {
  CLOUD_NEW_USER_LEAD: "https://hooks.zapier.com/hooks/catch/19944880/2slhwzk/",
  CLOUD_UPDATE_HUBSPOT_PROPERTIES:
    "https://hooks.zapier.com/hooks/catch/19944880/2fyyeye/",
  EMAIL_CUSTOM_AI_ONBOARDING:
    "https://hooks.zapier.com/hooks/catch/19944880/2cmmliq/",
};

export type HubspotZaps = keyof typeof HUBSPOT_ZAPS;

export const ZAPS = {
  AI_USER_SURVEY: "https://hooks.zapier.com/hooks/catch/19944880/2538o3o/",
  NEW_USER_LEAD: "https://hooks.zapier.com/hooks/catch/18072881/2t2fppi/",
  ONBOARDING_MICROSURVEY:
    "https://hooks.zapier.com/hooks/catch/19944880/ujeulgi/",
};
